import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
import { defaultTheme } from "./theme";
import './assets/styles/variables.css'
import './assets/styles/main.css'
import './assets/styles/components.css'
import './assets/styles/animations.css'
import './assets/styles/layout.css'

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: { ...defaultTheme }
    }
  }
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  vuetify,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js